import success from './result/success'
import fail from './result/fail'

export default {
  'result.response.finishTime': '完成时间：',
  'result.response.code': '响应码：',
  'result.response.size': '数据包：',
  'result.response.time': '总耗时：',

  ...success,
  ...fail
}
